import { MRT_Row } from '@talentmesh/table';
import { TypographySmall } from '@talentmesh/ui/components/typography';
import { TeamMember } from '@/Models/TeamMember';

interface RoleProps {
    row: MRT_Row<TeamMember>;
}

function Role({ row }: RoleProps) {
    return <TypographySmall>{row.original.role}</TypographySmall>;
}

export default Role;
